module.exports = __webpack_public_path__ + "img/screen_empty_activityfeed.eb137148.png";